import { Reveal } from "./Reveal";

export default function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = "left",
  light = false,
  testId,
}) {
  return (
    <Reveal blur className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {eyebrow && (
        <div
          className={`mb-5 inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.25em] ${
            light ? "text-sky-300" : "text-sky-400"
          }`}
          data-testid={testId ? `${testId}-eyebrow` : undefined}
        >
          <span className="h-px w-8 bg-sky-400/60" />
          {eyebrow}
        </div>
      )}
      <h2 className="font-heading text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-5 text-base leading-relaxed text-slate-400 lg:text-lg">
          {subtitle}
        </p>
      )}
    </Reveal>
  );
}
